module.exports = __webpack_public_path__ + "pattern3.86f4c2397325bcd6305c.png";


//////////////////
// WEBPACK FOOTER
// /Users/liyankai/Documents/github/seiya_web.git/src/assets/images/pattern3.png
// module id = ../../../../../src/assets/images/pattern3.png
// module chunks = styles